/** Academy teams at U13 or younger should not collect player contact details. */
export function isAcademyU13OrYounger() {
    const selectedTeamType = sessionStorage.getItem('selected_team_type');
    const ageGroup = sessionStorage.getItem('selected_team_age_group');

    if (selectedTeamType !== 'academy' || !ageGroup) {
        return false;
    }

    const ageMatch = ageGroup.match(/U(\d+)s?/i);
    if (!ageMatch || ageMatch.length < 2) {
        return false;
    }

    return parseInt(ageMatch[1], 10) <= 13;
}

export const fetchMatchPlayers = async (matchId) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/get_attendance.php?match_id=${matchId}`);
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
        const result = await response.json();
        console.log('API Response:', result);
        
        if (result.success) {
            if (!Array.isArray(result.players)) {
                console.error('Players data is not an array:', result.players);
                return { allPlayers: [], whiteTeam: [], colourTeam: [] };
            }
            return {
                allPlayers: result.players,
                whiteTeam: result.players.filter(player => player.team?.toLowerCase() === 'white'),
                colourTeam: result.players.filter(player => player.team?.toLowerCase() === 'colour')
            };
        } else {
            console.error('Failed to fetch players:', result.error);
            return { allPlayers: [], whiteTeam: [], colourTeam: [] };
        }
    } catch (error) {
        console.error('Error fetching players:', error);
        return { allPlayers: [], whiteTeam: [], colourTeam: [] };
    }
}; 